export default __webpack_public_path__ + "static/media/light_calendar.2a0cd4be.svg";